import { BaseService } from './BaseService';

export class DrawingService extends BaseService {
    constructor() {
        let collectionName = 'drawing2d';
        super(collectionName);
    }
}
